<template>
	<ArticleCard
		:article="article"
		:base-link-classes="'display-block col-12 col-10-md col-offset-1-md col-8-lg col-offset-2-lg'"
		:classes="classes"
		:show-date="showDate"
		:show-cover-image="true"
		:show-divider="false"
		class="article-card-horizontal"
	>
		<div class="display-flex flex-wrap-wrap">
			<div
				:class="{ 'col-7-md': article?.coverImage?.asset.url ?? '' }"
				class="article-card-horizontal__text col-12"
			>
				<h2 class="heading-5 article-title">{{ article.title }}</h2>
				<p
					v-if="showDate"
					class="overline mt-50"
					:class="{
						'display-flex align-items-center': article.showNewBadge
					}"
				>
					<ArticleDate :date-string="article.date" />
					<Badge v-if="article.showNewBadge" class="ml-50" background="slate" text="New" size="medium" />
				</p>
				<p
					v-else-if="article.category"
					class="overline mt-50"
					:class="{
						'display-flex align-items-center': article.showNewBadge
					}"
				>
					{{ article.category.name }}
					<Badge v-if="article.showNewBadge" class="ml-50" background="slate" text="New" size="medium" />
				</p>
				<p v-if="article.abstract" class="mt-50 dark epsilon">{{ article.abstract }}</p>
			</div>
			<div
				v-if="article.coverImage?.asset?.url"
				class="article-card-horizontal__image col-12 col-5-md pl-250-md mb-50 mb-0-lg"
			>
				<ArticleCoverImage :cover-image="article.coverImage?.asset" />
			</div>
		</div>
	</ArticleCard>
</template>

<script setup lang="ts">
import ArticleCard from '@components/blog/article-card.vue';
import ArticleCoverImage from '@components/blog/article-cover-image.vue';
import ArticleDate from '@components/blog/article-date.vue';
import Badge from '@components/badges/badge-component.vue';
import { SanityArticleTeaser } from 'types/sanity/blog-education-center';

interface Props {
	article: SanityArticleTeaser;
	classes?: string;
	showDate?: boolean;
}

withDefaults(defineProps<Props>(), {
	classes: '',
	showDate: false
});
</script>
